import { render, staticRenderFns } from "./search_Component.vue?vue&type=template&id=0686478e&scoped=true&"
import script from "./search_Component.vue?vue&type=script&lang=js&"
export * from "./search_Component.vue?vue&type=script&lang=js&"
import style0 from "./search_Component.vue?vue&type=style&index=0&id=0686478e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686478e",
  null
  
)

export default component.exports